// External library
import Player from '@vimeo/player'

// Component
export default () => {
    const modals = document.querySelectorAll('.modal-video')

    // If there's no video modals, return
    if (!modals)
        return

    const control = (el) => {
        const iframe = el.querySelector('iframe')
        const video = el.querySelector('video')
        const vimeo = iframe
            && iframe.src.includes('vimeo')

        if (!video && !vimeo)
            return

        const videoPlayer = vimeo
            ? new Player(iframe)
            : video

        el.addEventListener('shown.bs.modal', () => videoPlayer.play())
        el.addEventListener('hide.bs.modal', () => videoPlayer.pause())
    }

    modals.forEach(modal => control(modal))
}
